import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { MatSidenav } from '@angular/material/sidenav';
import { TranslateService } from '@ngx-translate/core';
import { Subscription, filter } from 'rxjs';
import { RouterLinkEnum } from 'src/app/enums/router-link-enum';
import { StateService } from '../../state.service';
import { MenuItemDto } from '../sidenav/menu-item-dto';
import { SideNavService } from '../sidenav/sidenav.service';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css']
})

export class HeaderComponent implements OnInit, OnDestroy {

  isAuthenticated: boolean = false;
  userName: string = '';
  @Input() inputSideNav: MatSidenav | undefined;

  itemStyle: string = "";

  logoutHeader: string = '';

  menuItems: MenuItemDto[] = [];

  userDisplaySubscription: Subscription;
  authenticatedSubscription: Subscription;

  constructor(private stateService: StateService,
    private sideNavService: SideNavService,
    private translate: TranslateService)
  {}

  ngOnDestroy(): void {
      if (this.userDisplaySubscription) this.userDisplaySubscription.unsubscribe();
      if (this.authenticatedSubscription) this.authenticatedSubscription.unsubscribe();
  }

  ngOnInit(): void {

    this.translate
    .get(['header.logout'
  ])
    .subscribe((translations) => {
      this.logoutHeader = translations['header.logout'];
    });

    this.userDisplaySubscription = this.stateService.userDisplayName$.subscribe((currentUser: string)  => {
      this.userName = currentUser;
    });

    //filter to prevent null subscribe
    this.authenticatedSubscription = this.stateService.isAuthenticated$.pipe(filter(val => val != null)).subscribe((isAuthenticated) => {
      this.isAuthenticated = isAuthenticated;
      if (isAuthenticated)
      {
        this.menuItems.splice(0);
        this.addMenuItemsHeader();
        this.mouseLeaveLogout();
      }
      else this.menuItems.splice(0);

    });

  }


  onLogout(){
    this.stateService.logout();
    this.menuItems.splice(0);
  }

  addMenuItemsHeader()
  {
    let changePassword: MenuItemDto = {
      id: "",
      mainMenuItem: true,
      menuIcon: RouterLinkEnum.CHANGE_PASSWORD.menu,
      menuRouterLink:RouterLinkEnum.CHANGE_PASSWORD.link,
      menuSubTitle: RouterLinkEnum.CHANGE_PASSWORD.text,
      menuTitle: RouterLinkEnum.CHANGE_PASSWORD.text,
      style: "right-menu hyperlink mouseleave",
      profiles:RouterLinkEnum.CHANGE_PASSWORD.profiles,
      sort:""
    }

    this.menuItems.push(changePassword);
  }

  clickMenu() {
    this.sideNavService.toggle();
  }

  mouseEnter(itemMenu: MenuItemDto)
  {
    itemMenu.style =  "right-menu hyperlink mouseover";
  }

  mouseLeave(itemMenu: MenuItemDto)
  {
    itemMenu.style =  "right-menu hyperlink mouseleave";
  }

  mouseEnterLogout()
  {
    this.itemStyle =  "right-menu hyperlink mouseover";
  }

  mouseLeaveLogout()
  {
    this.itemStyle =  "right-menu hyperlink mouseleave";
  }
}
